module.exports = __webpack_public_path__ + "img/business-coach-017-1024x682.41b7ba11.jpg";